// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/McKinseySans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/McKinseySans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/McKinseySans-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
} */
.body {
  min-height: 100vh;
  font-family: "McKinseySans-Regular", "Arial", sans-serif;
  width: 100%;
}
@font-face {
  font-family: "McKinseySans-Regular";
  src: local("McKinseySans-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
}

@font-face {
  font-family: "McKinseySans-Light";
  src: local("McKinseySans-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: lighter;
  font-style: normal;
}

@font-face {
  font-family: "McKinseySans-Medium";
  src: local("McKinseySans-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: bolder;
  font-style: normal;
}
#widget-container .main {
  height: 50.75rem;
}
.p {
  font-family: "McKinseySans-Regular", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;EACE,iBAAiB;EACjB,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,mCAAmC;EACnC;8DAC4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC;8DAC0D;EAC1D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;8DAC2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD","sourcesContent":["/* * {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n} */\n.body {\n  min-height: 100vh;\n  font-family: \"McKinseySans-Regular\", \"Arial\", sans-serif;\n  width: 100%;\n}\n@font-face {\n  font-family: \"McKinseySans-Regular\";\n  src: local(\"McKinseySans-Regular\"),\n    url(\"./fonts/McKinseySans-Regular.otf\") format(\"opentype\");\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"McKinseySans-Light\";\n  src: local(\"McKinseySans-Light\"),\n    url(\"./fonts/McKinseySans-Light.otf\") format(\"opentype\");\n  font-weight: lighter;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"McKinseySans-Medium\";\n  src: local(\"McKinseySans-Medium\"),\n    url(\"./fonts/McKinseySans-Medium.otf\") format(\"opentype\");\n  font-weight: bolder;\n  font-style: normal;\n}\n#widget-container .main {\n  height: 50.75rem;\n}\n.p {\n  font-family: \"McKinseySans-Regular\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
